var map = {
	"./account-choose-icon.svg": "./src/assets/account/account-choose-icon.svg",
	"./account-icon-active.svg": "./src/assets/account/account-icon-active.svg",
	"./account-icon.svg": "./src/assets/account/account-icon.svg",
	"./developers-icon-active.svg": "./src/assets/account/developers-icon-active.svg",
	"./developers-icon.svg": "./src/assets/account/developers-icon.svg",
	"./members-icon-active.svg": "./src/assets/account/members-icon-active.svg",
	"./members-icon.svg": "./src/assets/account/members-icon.svg",
	"./notification-icon-active.svg": "./src/assets/account/notification-icon-active.svg",
	"./notification-icon.svg": "./src/assets/account/notification-icon.svg",
	"./pos-icon-active.svg": "./src/assets/account/pos-icon-active.svg",
	"./pos-icon.svg": "./src/assets/account/pos-icon.svg",
	"./sii-icon-active.svg": "./src/assets/account/sii-icon-active.svg",
	"./sii-icon.svg": "./src/assets/account/sii-icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/account sync recursive ^\\.\\/.*\\-icon.*\\.svg$";